import { FolderDetail } from "../../../domain/Folder/Folder"
import Forms from "../../../domain/Form/Forms"
import FoldersDataListAsTable from "./DataList/FoldersDataListAsTable"
import FoldersDataListAsBlock from "./DataList/FoldersDataListAsBlock"
import { ListAppearance } from '../button/AppearanceDropDown'


interface Props {
  folders: FolderDetail[]
  totalItems: number
  itemsPerPage: number
  handleDeleteFolder: (id: string) => void
  type: string | null
  forms: Forms[]
  state: string | null
  viewMode: ListAppearance
  sortConfig: { key: string, direction: 'asc' | 'desc' }
  requestSort: (key: string) => void
}

const FoldersDataList = ({ folders, totalItems, itemsPerPage, handleDeleteFolder, type, forms, state, viewMode, sortConfig, requestSort }: Props): JSX.Element => {
  if ('table' === viewMode) {
    return <FoldersDataListAsTable
      folders={folders}
      totalItems={totalItems}
      itemsPerPage={itemsPerPage}
      handleDeleteFolder={handleDeleteFolder}
      type={type}
      forms={forms}
      state={state}
      sortConfig={sortConfig}
      requestSort={requestSort}
    />
  }
  return <FoldersDataListAsBlock
    folders={folders}
    totalItems={totalItems}
    itemsPerPage={itemsPerPage}
    handleDeleteFolder={handleDeleteFolder}
    type={type}
    forms={forms}
    state={state}
  />
};

export default FoldersDataList;
